import { useState, useEffect, useCallback } from 'react';

export const useBarcodeScanner = (onScan) => {
  const [barcode, setBarcode] = useState('');

  const handleKeyDown = useCallback((event) => {
    const key = typeof event?.key === 'string' ? event.key : '';
    if (!key) return;

    // Ignore single character keys that are not part of a scan
    if (key.length > 1 && key !== 'Enter') {
      return;
    }

    if (key === 'Enter') {
      if (barcode.length > 3) { // A reasonable length for a SKU
        onScan(barcode);
      }
      setBarcode(''); // Reset for the next scan
    } else {
      setBarcode(prev => prev + key);
    }
  }, [barcode, onScan]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);
};
